import { createRoot } from 'react-dom/client';
import AdsgramWidgetModal from './AdsgramCpcWidgetModal';
export interface BoostTask {
  id: string | number;
  title?: string;
  description?: string;
  icon?: string;
  provider: string;
  link?: string;
  onClick: () => Promise<'success' | 'user_cancelled' | 'ads_not_found'>;
  onShowReward?: () => Promise<boolean>;
}

export interface BoostProvider {
  getName(): string;
  getAvailableTasks(): Promise<BoostTask[]>;
  startTask?(
    taskId: string | number,
  ): Promise<'success' | 'user_cancelled' | 'ads_not_found'>;
  resetError?(): void;
}
export class AdsgramCPCBoostProvider implements BoostProvider {
  private static instance: AdsgramCPCBoostProvider;
  private hasError: boolean = false;
  private modalRoot: HTMLDivElement | null = null;
  private root: ReturnType<typeof createRoot> | null = null;
  private constructor() {}

  static getInstance(): AdsgramCPCBoostProvider {
    if (!AdsgramCPCBoostProvider.instance) {
      AdsgramCPCBoostProvider.instance = new AdsgramCPCBoostProvider();
    }
    return AdsgramCPCBoostProvider.instance;
  }

  private cleanup() {
    if (this.root) {
      this.root.unmount();
      this.root = null;
    }

    if (this.modalRoot && document.body.contains(this.modalRoot)) {
      document.body.removeChild(this.modalRoot);
      this.modalRoot = null;
    }

    this.hasError = false;

    setTimeout(() => {
      window.postMessage({ eventType: 'tads_modal_closed' }, '*');
    }, 100);
  }

  async startTask(
    _taskId: string | number,
  ): Promise<'success' | 'user_cancelled' | 'ads_not_found'> {
    return new Promise((resolve, reject) => {
      try {
        this.modalRoot = document.createElement('div');
        document.body.appendChild(this.modalRoot);
        this.root = createRoot(this.modalRoot);

        const handleReward = () => {
          console.log('AdsgramCPC task completed successfully');
          this.cleanup();
          resolve('success');
        };

        const handleClose = () => {
          console.log();
          this.cleanup();
          resolve('user_cancelled');
        };

        const handleAdsNotFound = () => {
          console.log('AdsgramCPC ads not found');
          this.hasError = true;
          this.cleanup();
          resolve('ads_not_found');
        };

        this.root.render(
          <AdsgramWidgetModal
            isOpen={true}
            isClosing={false}
            onClose={handleClose}
            onReward={handleReward}
            onAdsNotFound={handleAdsNotFound}
            checkOnly={false}
          />,
        );
      } catch (error) {
        console.error('Error in Tads task:', error);
        this.cleanup();
        return Promise.resolve('ads_not_found');
      }
    });
  }

  async getAvailableTasks(): Promise<BoostTask[]> {
    if (this.hasError) {
      console.log(
        'AdsgramCPCBoostProvider: Skipping task due to previous error.',
      );
      return [];
    }

    const task: BoostTask = {
      id: 'adsgramCPC',
      title: 'Ускорить за рекламу (Adsgram)',
      provider: this.getName(),
      onClick: () => this.startTask('adsgramCPC'),
    };

    return [task];
  }

  getName(): string {
    return 'AdsgramCPC';
  }

  resetError() {
    console.log('AdsgramCPCBoostProvider: Resetting error state.');
    this.cleanup();
  }
}

export const adsgramCPCBoostProvider = AdsgramCPCBoostProvider.getInstance();
